import {
  Box,
  Checkbox,
  Grid,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import {
  blackColor,
  blackShade05,
  blackShade21,
  blueColor04,
  borderCart,
  borderTextBoxColor,
  copyBtnColor,
  greyColor40,
  greyColor42,
  greyColor47,
  greyColor5,
  greyColor8,
  greyShade25,
  lightRedColor,
  outOfStockColor,
  redColor,
  redColor01,
  tableHeaderColor,
  whiteColor,
  yellowShade01,
  yellowShade02,
} from "../../../configs/styles/muiThemes";
import SelectWithLabel from "../../../components/Input/SelectWithLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { textOneLines, textThreeLines, textTwoLines } from "../../../utils/styles";
import { toTitleCase } from "../../../utils/validationUtils";
import { ALL_STOCK_VARIANT_MOILE_HEADER } from "../../../utils/data";
import ModalCard from "../../../components/ModalCard";
import MobileAllStockVarinatCard from "../VariantPopup/MobileAllStockVarinatCard";
import MobileLowStockVariantCard from "../VariantPopup/MobileLowStockVariantCard";
import MobilePriceUpdateVariantCard from "../VariantPopup/MobilePriceUpdateVariantCard";
function AllStockMobileTab({
  index,
  productList,
  onSelectAll,
  selectedRows,
  totalCount,
  img,
  title,
  originalAmt,
  amt,
  endDate,
  startDate,
  onValueChange,
  isChecked,
  gst,
  gstRates,
  gstCode,
  errors,
  priceOff,
  validityDays,
  availability,
  alertQty,
  avlQty,
  minQty,
  maxQty,
  disabled,
  ondcEnabled,
  data,
  popuptab,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [toggleData, settoggleData] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const handleShowData = (data) => {
    settoggleData(data);
  };

  return (
    <Box
      sx={{
        // borderRadius: "6px",
        border: `1px solid ${tableHeaderColor}`,
        background: whiteColor,
        mb: { xs: 0, md: 1 },
      }}
    >
      <Box
        sx={{ p: "16px 16px 16px 16px" }}
        border={{
          xs: `1px solid ${errors?.length > 0 ? "red" : "none"}`,
          md: "none",
        }}
      >
        {matches ? (
          <Grid
            container
            display={"flex"}
            alignItems="center"
            rowSpacing={{ xs: 1.9, md: 3 }}
            columnSpacing={{ xs: 2, md: 3 }}
          >
            <Grid item md={3.8} xs={12}>
              <Box display="flex" alignItems="flex-start">
                <Checkbox
                  sx={{ ml: -1, ...styles.checkbox }}
                  checked={isChecked}
                  size={"large"}
                  onChange={() => {
                    onValueChange({ type: "itemChange", value: !isChecked });
                  }}
                />

                <Box ml={1} flex={1}>
                  <Typography
                    fontSize={{ xs: 13, md: 14 }}
                    color={blackColor}
                    fontWeight={{ xs: 600, md: 500 }}
                    lineHeight={1.5}
                    mb="0px !important"
                  >
                    {title}
                  </Typography>
                </Box>

                <StyledSwitch
                  sx={{ ml: 1, color: "red" }}
                  checked={availability}
                  onChange={() => {
                    if (availability) {
                      onValueChange({ type: "availability", value: ["No"] });
                    } else {
                      onValueChange({ type: "availability", value: ["Yes"] });
                    }
                  }}
                />
              </Box>
            </Grid>

            <Grid item md={1.7} xs={6}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                AVAILABLE QTY
              </Typography>

              <InputBox
                value={avlQty}
                onChange={({ target }) => {
                  const value = target.value;
                  const regex = /^(\d{0,7})$/;
                  if (regex.test(value) && target.value.charAt(0) !== "0") {
                    onValueChange({
                      type: "availableQuantity",
                      value: target.value,
                    });
                  }
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.7} xs={6}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                ALERT QTY
              </Typography>

              <InputBox
                value={alertQty}
                onChange={({ target }) => {
                  const value = target.value;
                  const regex = /^(\d{0,7})$/;
                  if (regex.test(value) && target.value.charAt(0) !== "0") {
                    onValueChange({
                      type: "alertQuantity",
                      value: target.value,
                    });
                  }
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.7} xs={4}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                MIN QTY
              </Typography>

              <InputBox
                value={minQty}
                onChange={({ target }) => {
                  const value = target.value;
                  const regex = /^(\d{0,7})$/;
                  if (regex.test(value) && target.value.charAt(0) !== "0") {
                    onValueChange({ type: "minOrderQuantity", value });
                  }
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.7} xs={4}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                MAX QTY
              </Typography>

              <InputBox
                value={maxQty}
                onChange={({ target }) => {
                  const value = target.value;
                  const regex = /^(\d{0,7})$/;
                  if (regex.test(value) && target.value.charAt(0) !== "0") {
                    onValueChange({ type: "maxOrderQuantity", value });
                  }
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.2} xs={4}>
              <Typography
                variant="h3"
                fontSize={{ xs: 11, md: 13 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                GST%
              </Typography>

              <SelectWithLabel
                value={gst?.replace("%", "") || ""}
                onValueChange={(value) => {
                  onValueChange({
                    type: "gstInfo",
                    value: { code: gstCode, gstPercentage: value },
                  });
                }}
                menuList={gstRates}
                valueSelector="value"
                isDashboardInput
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.7} xs={4}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                Original Price
              </Typography>

              <InputBox
                value={originalAmt}
                onChange={({ target }) => {
                  const value = target.value;
                  // const regex = /^(\d{0,7}|\d{0,7}\.)(?:\.\d{1,2})?$/;
                  // if (regex.test(value) && target.value.charAt(0) !== "0") {
                  //   onValueChange({
                  //     type: "productOriginalPrice",
                  //     value: target.value,
                  //   });
                  // }

                  const regex = /^\d{0,7}(\.\d{0,2})?$/;

                  if (regex.test(value)) {
                    onValueChange({
                      type: "productOriginalPrice",
                      value: value,
                    });
                  }
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.5} xs={4}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                % OFF
              </Typography>

              <InputBox
                value={priceOff}
                onChange={({ target }) => {
                  const newValue = target?.value?.replace(/[^0-9]/g, "");

                  onValueChange({
                    type: "priceOff",
                    value: newValue,
                  });
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.5} xs={4}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                Sale Price
              </Typography>

              <InputBox
                value={amt}
                onChange={({ target }) => {
                  const value = target.value;
                  const regex = /^\d{0,7}(\.\d{0,2})?$/;

                  if (regex.test(value)) {
                    onValueChange({
                      type: "productSalePrice",
                      value: value,
                    });
                  }

                  // const regex = /^(\d{0,7}|\d{0,7}\.)(?:\.\d{1,2})?$/;
                  // const regex = /^\d{0,7}(\.\d{0,2})?$/;
                  // if (
                  //   regex.test(value) &&
                  //   target.value.charAt(0) !== "0" &&
                  //   !isNaN(target.value)
                  // ) {
                  //   onValueChange({
                  //     type: "productSalePrice",
                  //     value: target.value,
                  //   });
                  // }
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.9} xs={4.2}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                Start Date
              </Typography>

              <TextField
                variant="standard"
                value={startDate}
                type="date"
                sx={styles.input}
                onChange={({ target }) => {
                  onValueChange({
                    type: "commerceStartDate",
                    value: target.value,
                  });
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    color: blackColor,
                    fontSize: { md: 14, xs: 11 },
                    fontWeight: 500,
                  },
                }}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.5} xs={3.6}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                VALIDITY(DAYS)
              </Typography>

              <InputBox
                value={validityDays}
                onChange={({ target }) => {
                  const newValue = target?.value?.replace(/[^0-9]/g, "");

                  onValueChange({
                    type: "validityDays",
                    value: newValue,
                  });
                }}
                maxLength={4}
                disabled={disabled}
              />
            </Grid>

            <Grid item md={1.9} xs={4.2}>
              <Typography
                variant="h3"
                fontSize={{ md: 13, xs: 11 }}
                color={greyShade25}
                fontWeight={{ xs: 500, md: 400 }}
                textTransform="uppercase"
                sx={styles.labelStyles}
              >
                End Date
              </Typography>
              <TextField
                variant="standard"
                type="date"
                value={endDate}
                sx={styles.input}
                onChange={({ target }) => {
                  onValueChange({
                    type: "commerceEndDate",
                    value: target.value,
                  });
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    color: blackColor,
                    fontSize: { md: 14, xs: 11 },
                    fontWeight: 500,
                  },
                }}
                disabled={disabled}
              />
            </Grid>

            {errors?.length > 0 ? (
              <Grid item md={12} mt={0}>
                {errors?.map((item, i) => (
                  <Typography
                    key={`error_${i}`}
                    color={"red"}
                    fontSize={12}
                    fontWeight={500}
                    display="block"
                    mr={1}
                    mb={0.5}
                    lineHeight="18px"
                  >
                    {item}
                  </Typography>
                ))}
              </Grid>
            ) : null}
          </Grid>
        ) : (
          <Grid
            container
            display={"flex"}
            alignItems="center"
            rowSpacing={{ xs: 1.9, md: 3 }}
            columnSpacing={{ xs: 2, md: 3 }}
            // backgroundColor={!toggleData ? whiteColor : greyColor42}
          >
            <Grid item md={3.8} xs={12}>
              <Box
                display="flex"
                //   alignItems="flex-start"
                justifyContent={"space-between"}
                flexDirection={{ xs: "column", md: "row" }}
              >
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  {/* <Checkbox
                      sx={{ ml: -1, ...styles.checkbox }}
                      checked={isChecked}
                      size={"large"}
                      onChange={() => {
                        onValueChange({
                          type: "itemChange",
                          value: !isChecked,
                        });
                      }}
                    /> */}
                  <Box sx={styles.imgContainer}>
                    <Box
                      component="img"
                      src={img}
                      height={"30px"}
                      maxWidth={"30px !important"}
                    />
                  </Box>
                  <Typography
                    fontSize={{ xs: 13, md: 14 }}
                    color={blackColor}
                    fontWeight={{ xs: 600, md: 500 }}
                    lineHeight={1.5}
                    mb="0px !important"
                    sx={{ ...textTwoLines }}
                  >
                    {title}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  gap={1}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  {/* <StyledSwitch
                      sx={{ color: "red" }}
                      checked={availability}
                      onChange={() => {
                        if (availability) {
                          onValueChange({
                            type: "availability",
                            value: ["No"],
                          });
                        } else {
                          onValueChange({
                            type: "availability",
                            value: ["Yes"],
                          });
                        }
                      }}
                    /> */}
                  <Box display="flex" alignItems="center" gap={1} ml={6}>
                    <Typography
                      fontSize={11}
                      color={blackShade21}
                      sx={{
                        textDecoration: "line-through",
                      }}
                    >
                      ₹ {originalAmt}
                    </Typography>

                    <Typography
                      fontSize={12}
                      fontWeight={600}
                      color={blueColor04}
                    >
                      ₹ {amt}
                    </Typography>

                    <Box sx={styles.percentageOffTag}>{priceOff} %</Box>

                    <Typography
                      fontSize={11.5}
                      fontWeight={400}
                      color={greyColor40}
                    >
                      ONDC Enabled :{" "}
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: ondcEnabled ? copyBtnColor : outOfStockColor,
                        }}
                      >
                        {toTitleCase(ondcEnabled || "No")}
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={styles.iconContainer()}
                    onClick={() => {
                      handleShowData((prev) => !prev);
                    }}
                    mr={-1}
                  >
                    {toggleData ? (
                      <ExpandMoreIcon
                        sx={styles.icon(matches ? whiteColor : "#e83658")}
                      />
                    ) : (
                      <ExpandLessIcon
                        sx={styles.icon(matches ? whiteColor : "#e83658")}
                      />
                    )}
                  </Box>
                </Box>
                <Typography
                  fontSize={11.5}
                  fontWeight={400}
                  color={greyColor40}
                  // textAlign={"center"}
                  ml={6}
                >
                  No. Of Varaints :{" "}
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: blackColor,
                    }}
                  >
                    0
                  </span>
                </Typography>
              </Box>
            </Grid>

            {toggleData && (
              <Grid item md={3.8} xs={12}>
                <Box sx={styles.tableWrapper}>
                  <TableContainer sx={styles.tableContainer} component={Box}>
                    <Table aria-label="simple table" size="small">
                      <TableHead>
                        <TableRow
                          sx={{
                            position: "sticky !important",
                            top: 0,
                            backgroundColor: greyColor42,
                            zIndex: 20,
                            borderRadius: "8px",
                          }}
                        >
                          {ALL_STOCK_VARIANT_MOILE_HEADER?.map(
                            (item, index) => {
                              //   const selectedRows = getSelectedInventoryRowCount(
                              //     allStockUpdateProducts
                              //   );

                              return (
                                <TableCell
                                  key={item.title}
                                  sx={{
                                    ...styles.tableCell,
                                    // ...styles.colSticky,
                                  }}
                                >
                                  <Box sx={{ fontSize: 12 }}>
                                    {item?.title}{" "}
                                  </Box>
                                </TableCell>
                              );
                            }
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ backgroundColor: whiteColor }}>
                        <TableRow
                          key={`Price_Update_500`}
                          sx={{
                            borderBottom: `1px solid ${borderTextBoxColor}`,
                            verticalAlign: "top",
                          }}
                        >
                          <TableCell
                            sx={{
                              ...styles.tableStickyLeft1Cell,
                            }}
                          >
                            <Box display="flex" alignItems="center" gap={1.2}>
                              {/* <Checkbox
                              sx={{ ...styles.checkbox, mt: 1 }}
                              checked={false}
                              onChange={() => {
                                // handleInputChange(
                                //   {
                                //     type: "itemChange",
                                //     value: !productInfo?.itemChange,
                                //   },
                                //   index
                                // );
                              }}
                            /> */}

                              <Typography
                                variant="body1"
                                title={"Relaxing Lavender Pocket Gel Freshner"}
                                sx={{
                                  ...styles.prodNameBox,
                                  ...textOneLines,
                                }}
                              >
                                Apple Watch
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={styles.tableStickyLeft1Cell}>
                            <Typography
                              variant="body1"
                              sx={{
                                ...styles.prodNameBox,
                                ...textOneLines,
                              }}
                            >
                              Watch Series 9 GPS
                            </Typography>
                          </TableCell>
                          <TableCell
                            sx={styles.tableStickyLeft1Cell}
                            onClick={() => {
                              setopenModal(true);
                            }}
                          >
                            <Typography
                              variant="body1"
                              title={"Relaxing Lavender Pocket Gel Freshner"}
                              sx={{
                                ...styles.prodNameBox,
                                ...textOneLines,
                                textDecoration: "underline",
                                color: redColor01,
                              }}
                            >
                              more
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
      <ModalCard
        open={openModal}
        // open={true}
        handleClose={() => setopenModal(false)}
        width="30%"
      >
        { popuptab === "lowStock" ? (
          <MobileLowStockVariantCard data={data} />
        ) : popuptab === "outofStock" ? (
          <MobileLowStockVariantCard data={data} />
        ) : popuptab === "priceUpdate" ? (
          <MobilePriceUpdateVariantCard data={data} />
        ) :  (
          <MobileAllStockVarinatCard data={data} />
        ) }
      </ModalCard>
    </Box>
  );
}

export default AllStockMobileTab;

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 35,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(8px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: copyBtnColor,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : outOfStockColor,
    boxSizing: "border-box",
  },
}));

const InputBox = ({ value, onChange, maxLength, disabled }) => {
  return (
    <TextField
      variant="standard"
      value={value}
      sx={styles.input}
      onChange={onChange}
      disabled={disabled}
      InputProps={{
        disableUnderline: true,
        style: {
          color: blackColor,
          fontSize: { md: 14, xs: 11 },
          fontWeight: 500,
        },
      }}
      inputProps={{ maxLength: maxLength }}
      fullWidth
      autoComplete="off"
    />
  );
};

const styles = {
  checkbox: {
    p: 0,
    transform: "scale(0.95)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },

  input: {
    width: { md: "65%", xs: "100%" },
    fontSize: { md: 14.5, xs: 11 },
    fontWeight: 500,
    borderTop: "none",
    borderBottom: borderCart,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: whiteColor,
  },

  labelStyles: {
    display: { md: "none", xs: "block" },
    mt: { xs: 0, md: 3 },
    mb: { xs: 0.5, md: 0 },
  },
  iconContainer: (bgColor, hideMobile) => ({
    width: { md: "40px", xs: "20px" },
    height: { md: "40px", xs: "20px" },
    borderRadius: "50%",
    backgroundColor: whiteColor,
    display: { md: "flex", xs: hideMobile ? "none" : "flex" },
    alignItems: "center",
    justifyContent: "center",
  }),
  icon: (color) => ({ fontSize: { md: 20, xs: 26 }, color: color }),
  imgContainer: {
    width: "40px !important",
    height: "40px",
    borderRadius: "6px",
    border: "1px solid #e5e9f0",
    backgroundColor: whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  percentageOffTag: {
    fontSize: 10.5,
    fontWeight: 600,
    color: yellowShade01,
    bgcolor: yellowShade02,
    p: "0px 3px",
    borderRadius: "2px",
  },
  tableWrapper: {
    // width: "calc(100vw - 310px)",
    width: "100%",
    borderRadius: "8px",
    // border: `1px solid ${borderTextBoxColor}`,
    // bgColor: whiteColor,
  },
  tableContainer: {
    borderRadius: "8px",
    overflow: "scroll",
    maxHeight: "calc(100vh - 370px)",

    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },
  tableCell: {
    color: greyColor47,
    fontSize: "12.5px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRight: `1px solid ${whiteColor}`,
  },
  colSticky: {
    ":first-child": { position: "sticky", left: "0px" },
    // ":last-child": { position: "sticky", right: "-3px" },
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableBodyCell: (isError) => ({
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: isError ? lightRedColor : whiteColor,
    padding: "8px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,

    boxShadow: isError ? `0px -1px 0 0 ${redColor} inset` : "none",
  }),
  tableStickyLeftCell: {
    minWidth: "190px !important",
    maxWidth: "190px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
    position: "sticky",
    left: 0,
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableStickyLeft1Cell: {
    minWidth: "90px !important",
    maxWidth: "110px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
  },
  tableStickyLeft2Cell: {
    maxWidth: "150px !important",
    minWidth: "140px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
  },
  checkbox: {
    p: 0,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },
};
